import type { EnvironmentProviders, Provider } from '@angular/core';
import type { Route } from '@angular/router';

import { provideEffects } from '@ngrx/effects';

import { viewsDataProviders } from '@core/views-data';

import { NoopComponent } from './noop.component';
import { canActivateRedirectToFirst } from './redirect-to-first.guard';
import { canActivateDataSource } from '../data-source/data-source-playground.component';
import { ViewsLocalStorageService } from '../view/view-page/local-storage.service';
import { snapshotUpdateViewName } from '../view/view-page/view-page-sidebar/view-page-sidebar.effects';

export const viewEffectsProvider = provideEffects({ snapshotUpdateViewName });

// eslint-disable-next-line max-lines-per-function
export const provideDataSourceRouting = (
  providers: Array<Provider | EnvironmentProviders> = [],
  playground = false,
): Route[] => {
  const loadComponent = playground
    ? {
        loadComponent: () =>
          import('../data-source/data-source-playground.component').then(
            c => c.DataSourcePlaygroundComponent,
          ),
      }
    : {};
  return [
    {
      path: '',
      providers: [viewsDataProviders, ViewsLocalStorageService, viewEffectsProvider, ...providers],
      canActivate: [canActivateDataSource()],
      ...loadComponent,
      children: [
        {
          path: 'create',
          loadComponent: () =>
            import('../view/view-page/view-page.component').then(c => c.ViewsPageComponent),
          children: [
            {
              path: '',
              outlet: 'sidebar',
              loadComponent: () =>
                import('../view/view-page/create-view-sidebar/create-view-sidebar.component').then(
                  c => c.CreateViewSidebarComponent,
                ),
            },
          ],
        },
        {
          path: ':viewId',
          loadComponent: () =>
            import('../view/view-page/view-page.component').then(c => c.ViewsPageComponent),
          children: [
            {
              path: 'create',
              children: [
                {
                  path: '',
                  outlet: 'sidebar',
                  loadComponent: () =>
                    import(
                      '../view/view-page/create-view-sidebar/create-view-sidebar.component'
                    ).then(c => c.CreateViewSidebarComponent),
                },
              ],
            },
            {
              path: '',
              children: [
                {
                  path: '',
                  outlet: 'sidebar',
                  loadComponent: () =>
                    import('../view/view-page/view-page-sidebar/view-page-sidebar.component').then(
                      c => c.ViewPageSidebarComponent,
                    ),
                },
              ],
            },
          ],
        },
        {
          path: '',
          canActivate: [canActivateRedirectToFirst],
          component: NoopComponent,
        },
      ],
    },
  ];
};
